if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.swiper = null;
    }

    connectedCallback() {
      // Wait for Swiper to load
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.connectedCallback(), 100);
        return;
      }
      this.initSwiper();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') {
        return;
      }

      const swiperContainer = this.querySelector(`.swiper-announcement-${this.sectionId}`);
      if (!swiperContainer) return;

      const prevButton = this.querySelector('.announcement-bar__nav--prev');
      const nextButton = this.querySelector('.announcement-bar__nav--next');

      // Initialize Swiper only on mobile
      const initMobileSwiper = () => {
        if (window.innerWidth < 750 && !this.swiper) {
          this.swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
            },
            speed: 400,
          });
        } else if (window.innerWidth >= 750 && this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      };

      // Initialize on load
      initMobileSwiper();

      // Reinitialize on resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          initMobileSwiper();
        }, 250);
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
